// extracted by css-extract-rspack-plugin
export default {"footer":"footer--SNr6PonTzh0QkzeI","lLite":"l-lite--SDtB0weYPfkKSAHp","xsFriendly":"xs-friendly--TozkWSnP90QnKrj5","abstractLinkLoading":"abstract-link-loading--lPR0M0SOwdInNxtX"};